import React, { useContext, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { UserContext } from "../../App";
import { createAgents,  useAgents } from "../../utils/agents";
import { useParams } from "react-router-dom";

export default function AgentAddContent({ agent }) {
  const history = useHistory();
  const { userInfos } = useContext(UserContext);
  const { agentId } = useParams()
  const { editAgentByIdWithToken } = useAgents();
  const [isFetching, setIsFetching] = useState(false);
  const [errors, setErrors] = useState([]);

  const [form, setForm] = useState({
    twilioPhoneNumber: "",
    twilioAccountSID: "",
    twilioAuthToken: "",
    label: "",
    businessName: "",
    prompt: ""

  });

  const selectedAgent = useMemo(() => {
    if (!agentId) return null;
    if (Array.isArray(agent)) return agent.find((item) => item.id === agentId);
    return agent?.[agentId] || null;
  }, [agent, agentId]);

  useEffect(() => {
    if (selectedAgent) {
      setForm({
        twilioPhoneNumber: selectedAgent.twilioPhoneNumber || "",
        twilioAccountSID: selectedAgent.twilioAccountSID || "",
        twilioAuthToken: selectedAgent.twilioAuthToken || "",
        label: selectedAgent.label || "",
        businessName: selectedAgent.businessName || "",
        prompt: selectedAgent.prompt || ""
      })
    } 
  }, [selectedAgent]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((old) => ({
      ...old,
      [name]: value,
    }));
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    if (handleValidation()) {
      try {
        if (agentId) {
          await editAgentByIdWithToken(agentId,form)
        } else {
          await createAgents(userInfos.jwt, form);
        }

        setIsFetching(false);
        history.push("/agents");
      } catch (error) {
        setIsFetching(false);
        const details = error.response?.data?.details;
        const formattedDetails =
          typeof details === "string"
            ? details
            : details?.message
              ? Array.isArray(details.message)
                ? details.message.join(", ")
                : details.message
              : details
                ? JSON.stringify(details)
                : "";
        const backendError =
          error.response?.data?.error
            ? `${error.response.data.error}${formattedDetails ? ` ${formattedDetails}` : ""}`
            : error.message || "Failed to create or edit agent. Please try again.";

        setErrors([backendError]);
      } finally {
        setIsFetching(false)
      }
    }
  }

  function handleValidation() {
    let valid = true;
    let message = [];

    if (!form.twilioPhoneNumber) {
      valid = false;
      message.push("Veuillez entrer un numéro Twilio.");
    }
    if (!form.twilioAccountSID) {
      valid = false;
      message.push("Veuillez entrer un SID Twilio.");
    }
    if (!form.twilioAuthToken) {
      valid = false;
      message.push("Veuillez entrer un token Twilio.");
    }
    if (!form.label) {
      valid = false;
      message.push("Veuillez entrer un label.");
    }
    if (!form.businessName) {
      valid = false;
      message.push("Veuillez entrer un nom d'entreprise.");
    }
    if (!form.prompt) {
      valid = false;
      message.push("Veuillez entrer un prompt.");
    }

    setErrors(message);
    return valid;
  }

  const FormAlert = () => {
    return errors.length > 0 ? (
      <div
        className="alert alert-danger mt-3"
        role="alert"
        style={{ flexDirection: "column", borderRadius: "0" }}
      >
        {errors.map((error, index) => (
          <div
            className="alert-text"
            key={index}
            style={{ alignSelf: "flex-start" }}
          >
            {error}
          </div>
        ))}
      </div>
    ) : null;
  };

  const buttonText = isFetching ? (
    <button type="submit" className="btn btn-primary" disabled>
      {agentId ? "Mise à jour..." : "Création..."}
    </button>
  ) : (
    <button type="submit" className="btn btn-primary">
      {agentId ? "Modifier Agent" : "Créer Agent"}
    </button>
  );



  console.log('agentId ', agentId)
  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container kt-container--fluid">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title"> {agentId ? "Modifier un agent" : "Ajouter un agent"}</h3>
          </div>
        </div>
      </div>

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">{agentId ? "Modifier les données de l'agent" : "Données de l'agent"}</h3>
            </div>
          </div>
          <form onSubmit={handleFormSubmit} className="kt-form">
            <div className="kt-portlet__body">
              <div className="kt-section kt-section--first">
                <div className="kt-section__body">

                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Numéro Twilio:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="twilioPhoneNumber"
                        placeholder="Twilio Phone Number "

                        value={form.twilioPhoneNumber}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">SID Twilio:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="twilioAccountSID"
                        placeholder="Twilio Account sid"

                        value={form.twilioAccountSID}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Auth Token Twilio:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="twilioAuthToken"
                        placeholder="Twilio Auth Token"
                        value={form.twilioAuthToken}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Label:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="label"
                        placeholder="Label for Phone Number"

                        value={form.label}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Nom d'entreprise:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="businessName"
                        placeholder="Label for Company Name"

                        value={form.businessName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Prompt:</label>
                    <div className="col-lg-6">
                      <textarea
                        className="form-control"
                        name="prompt"
                        placeholder="Enter Prompt"
                        value={form.prompt}
                        onChange={handleChange}
                        rows={4}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="kt-portlet__foot">
              <div className="kt-form__actions" style={{ display: "flex", gap: "1rem" }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={history.goBack}
                >
                  Retour
                </button>
                {buttonText}
              </div>
            </div>
          </form>
          <FormAlert />
        </div>
      </div>
    </div>
  );
}
